export default __webpack_public_path__ + "static/media/collector.614a4a37.png";